import { Component } from 'react';
import { Card, CardText } from 'reactstrap';
import Atome from './Atome';
import BankTransfer from './BankTransfer';
import CreditCard from './CreditCard';
import VirtualAccount from './VirtualAccount';

export default class Payment extends Component{
    render(){
        return(
            <div id="helps-container">
                <p className="title-card" style={{ marginTop: "80px" }}>Metode Pembayaran</p>
                <CardText className="text-center">
                  Anda dapat memilih salah satu metode pembayaran pada saat Checkout dan tidak bisa mengganti metode pembayaran yang lain ketika telah melakukan submit pada form Checkout. Berikut panduan cara membayarnya:
                </CardText>
                <Card body>
                  <CreditCard/>
                  <Atome/>
                  <BankTransfer/>
                  <VirtualAccount/>
                </Card>
            </div>
        )
    }
}